
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    name: 'step-component',
})
export default class StepComponent extends Vue {
  @Prop({}) private list!: any;
  @Prop({default: 0}) private active!: number;
  @Prop({default: false}) private IsOnlinePay!: boolean;
  @Prop({}) private activeColor!: string;
  @Prop({}) private disablColor!: string;
}
